<template>
<path d="M2.8 9L3.4 6.14286L1 5.28571L5.2 1L4.6 3.85714L7 4.71429L2.8 9Z" stroke="#8794B5" stroke-linecap="round" stroke-linejoin="round"/>
</template>
